import { Icon } from 'components/Icons';
import { BREAK_ } from 'constants';
import React from 'react';
import styled from 'styled-components';

const InfoItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 80px;

  ${BREAK_.md_dn} {
    width: 100%;
    gap: 40px;
    justify-content: space-between;
  }
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;

const PageHighlights = ({ udbf }) => {
  const highlights = udbf?.[0]?.UnitHighlights || [];

 

  return (
    <InfoItemsWrapper>
      {highlights.map((item, index) => {
        const isOutdoorSpace = item.Label === "Uderum";
        return (
          <InfoItem key={index}>
            <Icon
              icon={item.Icons}
              isFaIcon={item.Icons === "compas"}
              size={item.Icons === "compas" ? "xl" : ""}
              sx={{
                width: "24px",
                height: "24px",
              }}
            />
            <div className="paragraph1-light" style={{ marginTop: "8px" }}>
              {item.Label}
            </div>

            {isOutdoorSpace ? (
              <div className="h4">
                Fransk altan<br />Altan<br />Terrasse
              </div>
            ) : (
              <div className="h4">{item.Value}</div>
            )}
          </InfoItem>
        );
      })}
    </InfoItemsWrapper>
  );
};

export default PageHighlights;
